import * as firebase from "firebase/app";
import "firebase/auth";

const logout = () => {
  firebase.auth().signOut();
};

export default logout;
